import clsx from "clsx"

type TextProps = {
    size?: 'small' | 'medium' | 'large' | 'xlarge'
    text: string
    className?: string
    bold?: boolean
    semibold?: boolean
}

const Text = ({ text, className, bold = false, semibold = false, size = 'medium' }: TextProps) => {
    return (
        <p className={clsx(className, 'text-blue', bold && 'font-bold', semibold && 'font-semibold', size === 'large' && 'text-md md:text-lg leading-tight', size === 'medium' && 'text-base leading-tight', size === 'small' && 'text-sm leading-tight', size === 'xlarge' && 'text-lg lg:text-xl leading-tight')}>
            {text}
        </p>
    )
}

export default Text